var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_el),expression:"show_el"}],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{key:"MatchText",domProps:{"innerHTML":_vm._s(_vm.get_match_val)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }